import { Ticket } from '../../types/ticket';
import { Rule } from '../types/Rule';
import { RuleContext } from '../types/RuleContext';

export class IdentifyTicketWithCarouselIdRule implements Rule {
  apply(context: RuleContext): Ticket[] {
    const { tickets } = context;
    const dateTimeMap = new Map();
    tickets.forEach(ticket => {
      ticket.type.forEach(type => {
        type.dates.forEach(dateObj => {
          const dateTime = `${dateObj.date} ${dateObj.time}`;

          // If an entry for this date and time already exists, set the idCarouselRef
          if (dateTimeMap.has(dateTime)) {
            type.idCarouselRef = dateTimeMap.get(dateTime);
          } else {
            // Otherwise, add the entry to the map with the parent group ID
            dateTimeMap.set(dateTime, ticket.id);
            type.idCarouselRef = ticket.id;
          }
        });
      });
    });

    return tickets;
  }
}
